import { render } from "./WpeDateTime.vue?vue&type=template&id=1c0d6104"
import script from "./WpeDateTime.vue?vue&type=script&lang=js"
export * from "./WpeDateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeDateTime.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c0d6104"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0d6104', __exports__)) {
    api.reload('1c0d6104', __exports__)
  }
  
  module.hot.accept("./WpeDateTime.vue?vue&type=template&id=1c0d6104", () => {
    api.rerender('1c0d6104', render)
  })

}


export default __exports__